import {
  GETLOYALTYPOINTSLIST_SUCCESS,
  GETLOYALTYPOINTSLIST_FAILED,
  RESET_GETLOYALTYPOINTSLIST,
  LOADING_GETLOYALTYPOINTSLIST,
  NETWORK_ERROR_GETLOYALTYPOINTSLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetLoyaltyPointsList = () => {
  return { type: RESET_GETLOYALTYPOINTSLIST };
};

const getLoyaltyPointsListReq = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETLOYALTYPOINTSLIST });
  await partnerServices
    .post("getLoyaltyPointsList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getLoyaltyPointsListSuccess(res.data));
          break;
        default:
          dispatch(getLoyaltyPointsListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETLOYALTYPOINTSLIST,
        payload: err,
      });
    });
};
function getLoyaltyPointsListSuccess(data) {
  return {
    type: GETLOYALTYPOINTSLIST_SUCCESS,
    payload: data,
  };
}
function getLoyaltyPointsListFailed(data) {
  return {
    type: GETLOYALTYPOINTSLIST_FAILED,
    payload: data,
  };
}

export { resetGetLoyaltyPointsList, getLoyaltyPointsListReq };
